export default "__VITE_ASSET__900e143a__"